import React, { useEffect } from 'react'
import { isEmpty } from 'lodash/lang'
import Masonry from 'react-responsive-masonry'
import EducationItem from './EducationItem/EducationItem'
import styles from '../UserCard.module.scss'
import { setEducationInfo } from '../../../redux/actions/userCard.action'
import { useDispatch } from 'react-redux'
import { ReactComponent as NoInfoImage } from '../../../assets/images/education_stub.svg'
import { useMediaQuery } from '@mui/material'

const Education = ({ userCardData }) => {
  const dispatch = useDispatch()
  const isOneColumn = useMediaQuery('(max-width:1199.98px)')
  const { education } = userCardData

  useEffect(() => {
    return () => {
      dispatch(setEducationInfo([]))
    }
  }, [dispatch])

  if (isEmpty(education)) {
    return (
      <div className={styles.noInfo}>
        <NoInfoImage width={isOneColumn ? '100%' : 400} height={isOneColumn ? 'auto' : 260} />
        <p>You don’t have any educations yet</p>
      </div>
    )
  } else {
    return (
      <Masonry columnsCount={isOneColumn ? 1 : 2} gutter='16px'>
        {education?.map((education, index) => {
          return (
            <EducationItem
              key={index}
              title={education.collegeName}
              items={education.values}
              period={education.period}
              files={education.files}
            />
          )
        })}
      </Masonry>
    )
  }
}

export default Education
